import { Outlet } from 'react-router-dom';

import { consoleAppConfig } from '@/console/app/config/console-app-config';
import { VscodeSessionGate } from '@/console/app/routes/vscode/vscode-session-gate';
import { FullscreenLoader } from '@/shared/components/ui/fullscreen-loader/fullscreen-loader';
import { AppConfigProvider } from '@/shared/features/app-config/context/app-config-context';
import { ErrorBoundary } from '@/shared/features/error/components/error-boundary/error-boundary';
import { TCustomRouteObject } from '@/shared/types/router.types';

export const vscodeRoute: TCustomRouteObject = {
  path: '/vscode/:sessionId',
  Component: () => (
    <AppConfigProvider value={consoleAppConfig}>
      <VscodeSessionGate>
        <Outlet />
      </VscodeSessionGate>
    </AppConfigProvider>
  ),
  hydrateFallbackElement: <FullscreenLoader />,
  errorElement: <ErrorBoundary />,
  children: [
    {
      index: true,
      lazy: async () => {
        const { VscodeRoute } = await import('./vscode');
        return { Component: VscodeRoute };
      },
    },
  ],
};
